import React from "react";
import { ProjectName } from "../../../Config";
// import SFLlogoIcon from '../../SVG/SFLlogoIcon'

function Error() {
  return (
    <div className="noPageFound">
      <img
        src={`/${ProjectName}/Assets/Images/SFL_Logo_Secondary.png`}
        alt="company logo"
      />
      <p>Page Not Found!</p>
    </div>
  );
}

export default Error;
